module.exports = __webpack_public_path__ + "static/media/prism concept - simpler tabs and search visuals.b266ac23.png";